const redis = require('redis');
const EngineRedis = require('cacheman-redis');
const { configs } = require('../config/build');
const bog = require('../utils/moreBog');

const DEFAULT_CONFIG = configs.redis;

const getRedisConfig = () => DEFAULT_CONFIG;

const writeClient = redis.createClient(getRedisConfig().write);
const readClient = redis.createClient(getRedisConfig().read);

writeClient.on('error', err => {
  bog.error('writeClient error: ', err);
});
readClient.on('error', err => {
  bog.error('readClient error: ', err);
});

const REDIS_WRITE_ENGINE = new EngineRedis({
  client: writeClient,
});

const REDIS_READ_ENGINE = new EngineRedis({
  client: readClient,
});

module.exports = {
  REDIS_WRITE_ENGINE,
  REDIS_READ_ENGINE,
};
